export default __webpack_public_path__ + "static/media/Services - Training.2899148c.jpeg";